//import scroll-lock package dependancy
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { setFillGapMethod, addFillGapTarget, addFillGapSelector, getCurrentPageScrollBarWidth } from 'scroll-lock';
//import overlayscrollbars dependancy
import OverlayScrollbars from 'overlayscrollbars';

let modalToggle;
let modal;
let timeout;
const setOverlay = () => {

  modalToggle = document.querySelectorAll('[data-toggle="modal"]');
  modal = document.querySelectorAll('[data-modal-overlay]');

  for (let i = 0; i < modalToggle.length; i++) {
    modalToggle[i].addEventListener('click', overlayReveal );
  }

  //control navigation
  document.addEventListener('click', function() {

    if (event.target.matches('[data-nav-link]') || event.target.matches('[data-modal-close]')) {
      //close modal
      let modalActive = document.querySelectorAll('[data-modal-overlay="active"]:not([contact-overlay])'); 
      for (var i = 0; i < modalActive.length; i++) {
        // Pass the current modal number as the target to ensure body classes are removed
        removeActiveState(modalActive[i], modalActive[i].getAttribute('modal-number'));
      }

    }

  }, false);


  // listen for escapeKey state
  document.addEventListener('keydown', function() {

    // if esc key pressed remove state
    if (event && event.key === 'Escape') {
     // if esc key was not pressed in combination with ctrl or alt or shift
        const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
        if (isNotCombinedKey) {
          // escape key was pressed with out any group keys
          
          // removeActiveState for modal;
          let modalActive = document.querySelectorAll('[data-modal-overlay="active"]:not([contact-overlay])'); 
          for (var i = 0; i < modalActive.length; i++) {
            // Pass the current modal number as the target
            removeActiveState(modalActive[i], modalActive[i].getAttribute('modal-number'));
          }
        }
        // console.log('esc key pressed');
    }

  }, false);  


  //set fillGapMethod for scroll-lock
  var method = 'padding'; //Available methods: none, padding, margin, width, max-width
  setFillGapMethod(method);

  // set FillGapSelector
  // addFillGapSelector('html,body');

  // set fillGapTarget
  const $fillGapElement = document.querySelector('#header .inner');
  addFillGapTarget($fillGapElement);

  document.documentElement.style.setProperty('--scrollBarWidth', getCurrentPageScrollBarWidth() + 'px');

  resetActiveState()

}

const destroyOverlay = () => {
  modalToggle = '';
  modal = '';

  for (let i = 0; i < modalToggle.length; i++) {
    modalToggle[i].removeEventListener('click', overlayReveal );
  }
}

const overlayReveal = () => {
  
  let target = event.target.getAttribute('modal-number');

  for (let i = 0; i < modal.length; i++) {
    if ( modal[i].getAttribute('modal-number') != target) {

      if (modal[i].dataset.modalOverlay == 'active') {
        removeActiveState(modal[i], target);
      }

    }
    else {

      if (modal[i].dataset.modalOverlay == 'active') {
        //if modal is active remove it
        removeActiveState(modal[i], target);
      } else {
        //if modal is hidden show it
        setActiveState(modal[i], target);
      }

    }
  }

}

function removeActiveState(modal, target){
  console.log('removeActiveState');
  let canvas = document.querySelectorAll('canvas.overlay-canvas');
  let modalToggle = document.querySelectorAll('[data-toggle="modal"]');
  
  //Get the element that should scroll when page scrolling is disabled
  const $scrollableElement = modal.querySelector('[data-scrollable]');
  // Also, pass the element to the argument and enable scrolling on the page
  if (document.body.getAttribute('data-scroll-lock-locked')) {
    enablePageScroll($scrollableElement);
  }

  //remove canvas blur
  if (canvas.length) {
    canvas.forEach(canvas => {
      canvas.classList.remove('blurred');
    });
  }

  let currentModal = modal.getAttribute('modal-number');

  //remove active state
  modal.dataset.modalOverlay = '';
  // if another modal is opended while this modal closes, dont remove 'modal-active' class
  if ( target == currentModal ) {
    document.body.classList.remove('modal-active', 'overlay-'+currentModal);
  } else {
    // document.body.classList.remove('modal-active', 'overlay-'+currentModal);
  }
  //remove expanded toggle state
  for (let i = 0; i < modalToggle.length; i++) {
    if (modalToggle[i].getAttribute('modal-number') == currentModal) {
      modalToggle[i].setAttribute('aria-expanded', 'false');
    }
  }

}

function setActiveState(modal, target){
  let currentModal = modal.getAttribute('modal-number');
  let canvas = document.querySelectorAll('canvas.overlay-canvas');
  //add opening state to allow transition;
  modal.dataset.modalOverlay = 'active';
  document.body.classList.add('modal-active', 'overlay-'+currentModal);
  //expand toggle state
  for (let i = 0; i < modalToggle.length; i++) {
    if (modalToggle[i].getAttribute('modal-number') == target) {
      modalToggle[i].setAttribute('aria-expanded', 'true');
    }
  }
  //Get the element that should scroll when page scrolling is disabled
  const $scrollableElement = modal.querySelector('[data-scrollable]');
  //Pass the element to the argument and disable scrolling on the page
  disablePageScroll($scrollableElement);

  //set canvas blur
  if (canvas.length) {
    canvas.forEach(canvas => {
      canvas.classList.add('blurred');
    });
  }

}

function resetActiveState() {
  const $scrollableElement = document.querySelector('[data-scrollable]');
  // Also, pass the element to the argument and enable scrolling on the page
  if (document.body.getAttribute('data-scroll-lock-locked')) {
    enablePageScroll($scrollableElement);
  }
}

export {overlayReveal, setOverlay, destroyOverlay, removeActiveState, resetActiveState};
